var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item)?_c('div',[_c(_vm.item.model_type,{tag:"component",attrs:{"id":_vm.item.model_id,"ticket_id":_vm.item.id}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }